import axios from "axios";
import moment from "moment";

/* validatePolicy: "http://securedev.repubicindemnity.com/ripolicy/policyholder/validate/policy",
  claimsReview: "http://securedev.repubicindemnity.com/riclaims/claims", 
  http://securedev.republicindemnity.com/ripolicy/policyholder/validate/policy/25320301?injurydate=2019-01-05

  */

const endpoints = {
  fileClaim: "/riclaims/fnol/public/submit",
  validatePolicy: "/ripolicy/policyholder/validate/policy",
  claimsReview: "/riclaims/fnol/public/summary",
  initClaimsSubmit: "/riclaims/fnol/public/init"
};

// const endpoints = {
//   fileClaim: "http://LA1002594L.ri-net.com:5000/fnol/public/submit",
//   validatePolicy: "http://securedev.repubicindemnity.com/ripolicy/policyholder/validate/policy",
//   claimsReview: "http://LA1002594L.ri-net.com:5000/fnol/public/summary",
//   initClaimsSubmit: "http://la1002594l.ri-net.com:5000/fnol/public/init"
// };

// const ValidatePublicPolicy = params => {
//   var validated = false;
//   // format date to yyyy-mm-dd
//   var injuryDate = moment(params.injurydate).format("YYYY-MM-DD");
//   axios
//     .get(endpoints.validatePolicy + "/" + params.policynbr + "?injurydate=" + injuryDate)
//     .then(response => {
//       if (response.status === 200) {
//         validated = true;
//       } else {
//         validated = false;
//       }
//     })
//     .catch(err => {
//       validated = false;
//     });
//   return validated;
// };

const ValidatePublicPolicy = params => {
  // format date to yyyy-mm-dd
  var injuryDate = moment(params.injurydate).format("YYYY-MM-DD");
  //alert(endpoints.validatePolicy + "/" + params.policynbr + "?injurydate=" + injuryDate);
  return axios.get(endpoints.validatePolicy + "/" + params.policynbr + "?injurydate=" + injuryDate);
};

const ClaimsReview = id => {
  return axios.get(endpoints.claimsReview + "/" + id).then(response => {
    return response.data;
  });
};

const FileClaim = data => {
  return axios
    .post(endpoints.fileClaim, data, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(res => res.data);
};

const InitClaim = idata => {
  return axios({
    method: "post",
    url: endpoints.initClaimsSubmit,
    data: idata
  }).then(res => res.data);
};

export { FileClaim, ValidatePublicPolicy, ClaimsReview, InitClaim };
